export const BU_SECTION_SIZES = [
  'medium',
  'large'
];
